import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function () {
    $('.option-radio').on('change', function () {
        const $selectedFreeText = $('.free-text', $(this).closest('.option-container'));
        const $unselectedFreeTexts = $('.free-text', $(this).closest('.likert-vertical-free-options-element')).not($selectedFreeText);
        $unselectedFreeTexts.val(''); // clear all the free text except the selected one
        $selectedFreeText.trigger('focus');
    });

    // On entering the free text field, select the corresponding radio button
    $('.likert-vertical-free-options-element .free-text').on('focusin', function () {
        const $selectedRadio = $('.option-radio', $(this).closest('.option-container'));
        if (!$selectedRadio.is(':checked')) {
            $selectedRadio.prop("checked", true).trigger('change');
        }
    });

    remainingChars.initOnce();
}